/* Forms marked data-tl-no-ajax must post normally: Shopify drops properties[] file
   uploads on AJAX adds. */
document.addEventListener('submit', function (e) {
  var f = e.target;
  if (f && f.matches && f.matches('form[data-tl-no-ajax]')) { e.stopImmediatePropagation(); }
}, true);

/* ---- delivery rules: one engine for the date picker and every countdown ----
   Reads snippets/delivery-rules.liquid. Day arithmetic is done on plain dates in
   UTC so the visitor's timezone can't shift a day, and "now" is read on the UK
   clock — a sender in Toronto or Delhi sees the same cut-off as one in London. */
window.TLDelivery = (function () {
  var el = document.getElementById('tl-delivery-rules');
  if (!el) return null;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return null; }
  var cutoff = parseInt(cfg.cutoffHour, 10); if (isNaN(cutoff)) cutoff = 14;
  var printDays = Math.max(0, parseInt(cfg.printDays, 10) || 0);
  var maxDays = Math.max(7, parseInt(cfg.maxDays, 10) || 90);
  var saturday = !!cfg.saturday;
  var closed = {};
  String(cfg.closedRaw || '').replace(/\d{4}-\d{2}-\d{2}/g, function (k) { closed[k] = true; return k; });
  /* days a carrier skips only some areas — the date stays pickable, with a note */
  var notes = {};
  String(cfg.regionalRaw || '').split(/\r?\n/).forEach(function (line) {
    var m = /^\s*(\d{4}-\d{2}-\d{2})\s+(.+?)\s*$/.exec(line);
    if (m) notes[m[1]] = notes[m[1]] ? notes[m[1]] + ' ' + m[2] : m[2];
  });

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fromKey(k) { var p = k.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])); }
  function toKey(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function addDays(k, n) { var d = fromKey(k); d.setUTCDate(d.getUTCDate() + n); return toKey(d); }
  function weekday(k) { return fromKey(k).getUTCDay(); }
  function daysBetween(a, b) { return Math.round((fromKey(b) - fromKey(a)) / 86400000); }

  function londonNow() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var d = new Date();                       // no timezone support: device clock
      return { key: d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()),
               secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() };
    }
    return { key: parts.year + '-' + parts.month + '-' + parts.day,
             secs: (parseInt(parts.hour, 10) % 24) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10) };
  }

  function isDispatchDay(k) { var w = weekday(k); return w !== 0 && w !== 6 && !closed[k]; }
  function isDeliveryDay(k) { var w = weekday(k); return w !== 0 && (w !== 6 || saturday) && !closed[k]; }
  function nextDay(k, test) { var n = k; for (var i = 0; i < 400; i++) { n = addDays(n, 1); if (test(n)) return n; } return n; }

  function plan() {
    var now = londonNow();
    var before = isDispatchDay(now.key) && now.secs < cutoff * 3600;
    var printDay = before ? now.key : nextDay(now.key, isDispatchDay);
    var dispatch = printDay;
    for (var i = 0; i < printDays; i++) dispatch = nextDay(dispatch, isDispatchDay);
    return { today: now.key, secs: now.secs, cutoff: cutoff, missed: !before,
             printDay: printDay, dispatch: dispatch,
             earliest: nextDay(dispatch, isDeliveryDay), latest: addDays(now.key, maxDays) };
  }

  function available(k, p) {
    p = p || plan();
    return !!k && /^\d{4}-\d{2}-\d{2}$/.test(k) && isDeliveryDay(k) && k >= p.earliest && k <= p.latest;
  }
  function longDate(k) { var d = fromKey(k); return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear(); }
  function parseLong(s) {
    var m = /(\d{1,2}) ([A-Za-z]+) (\d{4})/.exec(s || '');
    if (!m) return null;
    var mi = MONTHS.indexOf(m[2]);
    return mi < 0 ? null : m[3] + '-' + pad(mi + 1) + '-' + pad(+m[1]);
  }
  function relative(k, today) {
    var diff = daysBetween(today, k), d = fromKey(k);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    if (diff < 7) return DAYS[d.getUTCDay()];
    return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate();
  }

  function noteFor(k) { return notes[k] || ''; }

  /* A UK wall-clock time on a given day, as an instant — GMT or BST as that day falls */
  function londonInstant(k, hour, minute) {
    var p = k.split('-'), guess = Date.UTC(+p[0], +p[1] - 1, +p[2], hour, minute || 0, 0), shown = hour;
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date(guess)).forEach(function (x) { parts[x.type] = x.value; });
      shown = parseInt(parts.hour, 10) % 24;
    } catch (e) {}
    var diff = ((shown - hour) % 24 + 24) % 24; if (diff > 12) diff -= 24;
    return guess - diff * 3600000;
  }
  function prevDispatch(k) { var t = addDays(k, -1); for (var i = 0; i < 60 && !isDispatchDay(t); i++) t = addDays(t, -1); return t; }

  /* The last moment to order and still arrive on or before a date: back to the
     last delivery day, to the posting day before it, then back the making days. */
  function orderBy(k) {
    var target = k;
    for (var i = 0; i < 30 && !isDeliveryDay(target); i++) target = addDays(target, -1);
    var start = prevDispatch(target);
    for (var j = 0; j < printDays; j++) start = prevDispatch(start);
    return { key: start, at: londonInstant(start, cutoff, 0), target: target };
  }
  function hourLabel(h) { return h === 0 ? 'midnight' : h === 12 ? 'noon' : (h % 12) + (h < 12 ? 'am' : 'pm'); }

  return { plan: plan, available: available, isDeliveryDay: isDeliveryDay, noteFor: noteFor,
           orderBy: orderBy, londonInstant: londonInstant, cutoffLabel: function () { return hourLabel(cutoff); },
           longDate: longDate, parseLong: parseLong, relative: relative,
           weekday: weekday, daysBetween: daysBetween, MONTHS: MONTHS, pending: null };
})();

/* Thorns London — storefront behaviour.
   Rose rotator, character gauges, FAQ panels, sticky one-page nav,
   Royal Mail lookup, AJAX cart drawer. */
(function () {
  'use strict';
  var MAX = 7;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- rose ------------------------------------------------------------- */
  function initRose(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var stage = $('[data-tl-stage]', root), rotor = $('[data-tl-rotor]', root);
    if (!stage || !rotor) return;
    var angle = 0, dragging = false, lastX = 0;
    function render() { rotor.style.transform = 'rotateY(' + angle.toFixed(1) + 'deg)'; }
    function px(e) { return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX; }
    stage.addEventListener('mousedown', function (e) { dragging = true; lastX = px(e); });
    stage.addEventListener('touchstart', function (e) { dragging = true; lastX = px(e); }, { passive: true });
    window.addEventListener('mousemove', function (e) { if (dragging) { angle += (px(e) - lastX) * 0.55; lastX = px(e); render(); } });
    window.addEventListener('touchmove', function (e) { if (dragging) { angle += (px(e) - lastX) * 0.55; lastX = px(e); render(); } }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { angle -= 15; render(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { angle += 15; render(); e.preventDefault(); }
    });
    function sync(input) {
      var i = input.getAttribute('data-tl-input');
      var val = input.value.toUpperCase().slice(0, MAX);
      var t = $('[data-tl-row="' + i + '"] textPath', root);
      if (t) t.textContent = val;
      var row = input.closest('.imprint-row');
      if (!row) return;
      $$('.gauge i', row).forEach(function (tick, n) { tick.classList.toggle('on', n < val.length); });
      row.classList.toggle('full', val.length === MAX);
    }
    $$('[data-tl-input]', root).forEach(function (i) {
      i.addEventListener('input', function () { sync(i); }); sync(i);
    });
    render();
  }

  /* ---- FAQ -------------------------------------------------------------- */
  function initFaq() {
    $$('[data-tl-faq]').forEach(function (btn) {
      if (btn.dataset.ready === 'true') return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item'), panel = $('.faq-a', item);
        var open = item.classList.toggle('open');
        panel.style.maxHeight = open ? (reduce ? 'none' : panel.scrollHeight + 'px') : null;
      });
    });
    $$('[data-tl-cat]').forEach(function (tab) {
      if (tab.dataset.ready === 'true') return;
      tab.dataset.ready = 'true';
      tab.addEventListener('click', function () {
        var group = tab.closest('.help-layout');
        $$('[data-tl-cat]', group).forEach(function (t) { t.classList.toggle('active', t === tab); });
        $$('[data-tl-panel]', group).forEach(function (p) {
          p.style.display = p.getAttribute('data-tl-panel') === tab.getAttribute('data-tl-cat') ? 'block' : 'none';
        });
      });
    });
  }

  /* ---- one-page nav ------------------------------------------------------ */
  function initNav() {
    var nav = $('[data-tl-nav]');
    if (!nav || nav.dataset.ready === 'true') return;
    nav.dataset.ready = 'true';
    var links = $$('a[data-tl-anchor]', nav), bar = $('[data-tl-indicator]', nav);
    if (!links.length) return;
    function slide(a) {
      if (!bar || !a) return;
      bar.style.width = a.offsetWidth + 'px';
      bar.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      bar.classList.add('on');
    }
    function setCurrent(id) {
      var match = null;
      links.forEach(function (a) {
        var on = a.getAttribute('data-tl-anchor') === id;
        a.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) match = a;
      });
      slide(match);
    }
    links.forEach(function (a) {
      a.addEventListener('click', function () { setCurrent(a.getAttribute('data-tl-anchor')); });
      a.addEventListener('mouseenter', function () { slide(a); });
    });
    nav.addEventListener('mouseleave', function () {
      var cur = $('a[aria-current="true"]', nav);
      if (cur) slide(cur); else if (bar) bar.classList.remove('on');
    });
    /* Scroll spy. Ratio-based observers pick whichever section happens to overlap the
       most, which lags a section behind on long pages. Measuring which section has
       crossed a line just under the header is deterministic and always lands on the
       one you are actually looking at. */
    var targets = links.map(function (a) {
      var el = document.getElementById(a.getAttribute('data-tl-anchor'));
      return el ? { link: a, el: el } : null;
    }).filter(Boolean);

    if (targets.length) {
      var ticking = false, lastId = null;

      function activeId() {
        var line = (document.querySelector('[data-tl-header]') || {}).offsetHeight || 88;
        line += 48;   // must clear the scroll-margin a nav click lands on, or the previous section stays lit
        var doc = document.documentElement;
        /* at the very bottom nothing new can cross the line, so pin to the last section */
        if (window.innerHeight + window.pageYOffset >= doc.scrollHeight - 4) {
          return targets[targets.length - 1].el.id;
        }
        var current = null;
        for (var n = 0; n < targets.length; n++) {
          if (targets[n].el.getBoundingClientRect().top <= line) current = targets[n];
        }
        return current ? current.el.id : null;
      }

      function spy() {
        ticking = false;
        var id = activeId();
        if (id && id !== lastId) { lastId = id; setCurrent(id); }
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(spy); }
      }
      function absTop(el){ return el.getBoundingClientRect().top + window.pageYOffset; }
      targets.sort(function (a, b) { return absTop(a.el) - absTop(b.el); });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      spy();
    }
    window.addEventListener('resize', function () {
      var cur = $('a[aria-current="true"]', nav); if (cur) slide(cur);
    });
    if (location.hash) setCurrent(location.hash.slice(1));
  }

  function initMenu() {
    var btn = $('[data-tl-menu]'), menu = $('[data-tl-mobile-menu]');
    if (!btn || !menu || btn.dataset.ready === 'true') return;
    btn.dataset.ready = 'true';
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', menu).forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('open'); btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- Royal Mail tracking ---------------------------------------------- */
  function initTracking() {
    var form = $('[data-tl-track]');
    if (!form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    var input = $('[data-tl-track-input]', form), err = $('[data-tl-track-error]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = (input.value || '').replace(/[\s-]/g, '').toUpperCase();
      var ok = /^[A-Z0-9]{9,27}$/.test(id);
      if (err) err.hidden = ok;
      if (!ok) { input.focus(); return; }
      window.open('https://www.royalmail.com/track-your-item?trackNumber=' + encodeURIComponent(id), '_blank', 'noopener');
    });
    input.addEventListener('input', function () { if (err) err.hidden = true; });
  }

  /* ---- cart drawer ------------------------------------------------------- */
  function initCart() {
    var drawer = $('[data-tl-cart-drawer]'), overlay = $('[data-tl-cart-overlay]');
    if (!drawer) return;
    function open()  { drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden','false'); }
    function close() { drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); }
    $$('[data-tl-cart-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-tl-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* add to cart without leaving the page, then refresh the drawer markup.
       main-product.liquid sets data-tl-ready on the form when it takes the
       submit over — binding a second handler here posted the item twice. */
    var form = $('#product-form');
    if (form && !form.dataset.tlReady) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[name="add"]', form);
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
              { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(location.pathname + '?section_id=' + 'cart-refresh'); })
          .catch(function () {})
          .then(function () { location.reload(); });
      });
    }
  }

  /* two contact forms share a posted state — keep the confirmation on the right one */
  function scopeSuccess() {
    var notes = $$('[data-tl-success]');
    if (notes.length < 2) return;
    var hash = (location.hash || '').replace('#', '');
    if (!hash) return;
    notes.forEach(function (n) { if (n.getAttribute('data-tl-success') !== hash) n.style.display = 'none'; });
  }

  function boot() {
    $$('[data-tl-rose]').forEach(initRose);
    initFaq(); initNav(); initMenu(); initTracking(); initCart(); scopeSuccess();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


/* ---- dispatch countdown ---------------------------------------------------
   Counts down to the studio's real cut-off and rolls forward to the next working
   day once it passes. It does not restart on refresh and makes no claim about a
   discount ending, because neither would be true. */
(function () {
  var nodes = [].slice.call(document.querySelectorAll('[data-tl-countdown]'));
  if (!nodes.length) return;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function isWorkingDay(d) { var k = d.getDay(); return k !== 0 && k !== 6; }
  function nextWorkingDay(d) { var n = new Date(d); do { n.setDate(n.getDate() + 1); } while (!isWorkingDay(n)); return n; }

  function label(d, now) {
    var t = new Date(now); t.setHours(0, 0, 0, 0);
    var x = new Date(d);   x.setHours(0, 0, 0, 0);
    var diff = Math.round((x - t) / 86400000);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    if (diff < 7) return DAYS[d.getDay()];
    return DAYS[d.getDay()] + ' ' + d.getDate();
  }

  function tick() {
    var R = window.TLDelivery;
    if (R) {
      /* UK clock, bank holidays and the one theme-wide cut-off — the same answer
         the basket's date picker gives */
      var p = R.plan();
      var secs = R.daysBetween(p.today, p.printDay) * 86400 + p.cutoff * 3600 - p.secs;
      var hh = Math.floor(secs / 3600), mm = Math.floor(secs % 3600 / 60), ss = secs % 60;
      var left2 = hh >= 24 ? (Math.floor(hh / 24) + 'd ' + (hh % 24) + 'h')
                : hh > 0 ? (hh + 'h ' + mm + 'm') : (mm + 'm ' + ss + 's');
      nodes.forEach(function (n) {
        var out = n.querySelector('[data-tl-countdown-text]');
        out.textContent = 'Order within ' + left2 + ' and it can arrive ' + R.relative(p.earliest, p.today);
        n.classList.toggle('urgency--soon', secs < 3 * 3600);
      });
      return;
    }
    var now = new Date();
    nodes.forEach(function (n) {
      var hour = parseInt(n.getAttribute('data-cutoff-hour'), 10) || 14;
      var out = n.querySelector('[data-tl-countdown-text]');
      var cut = new Date(now); cut.setHours(hour, 0, 0, 0);
      var dispatch, missed = false;

      if (isWorkingDay(now) && now < cut) {
        dispatch = new Date(now);
      } else {
        missed = true;
        dispatch = nextWorkingDay(now);
        cut = new Date(dispatch); cut.setHours(hour, 0, 0, 0);
      }
      var arrive = nextWorkingDay(dispatch);
      var ms = cut - now;
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);
      var left = h > 0 ? (h + 'h ' + m + 'm') : (m + 'm ' + s + 's');

      if (!missed) {
        out.textContent = 'Order within ' + left + ' and we print it today — arrives ' + label(arrive, now);
      } else {
        out.textContent = 'Next print run is ' + label(dispatch, now) + ' — order within ' + left + ' to make it';
      }
      n.classList.toggle('urgency--soon', ms < 3 * 3600000);
    });
  }
  tick();
  setInterval(tick, 1000);
})();

/* ---- sticky buy bar: appears once the hero is out of view ---------------- */
(function () {
  var bar = document.querySelector('[data-tl-sticky]');
  var hero = document.querySelector('.hero');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        bar.hidden = true; bar.classList.remove('show');
        document.body.classList.remove('has-sticky');
      } else {
        bar.hidden = false;
        document.body.classList.add('has-sticky');
        requestAnimationFrame(function () { bar.classList.add('show'); });
      }
    });
  }, { threshold: 0.12 }).observe(hero);
})();


/* ---- gift add-ons: quick add. Safe to one-tap because these carry no personalisation. */
(function () {
  var btns = [].slice.call(document.querySelectorAll('[data-tl-addon]'));
  if (!btns.length) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var was = b.textContent;
      b.disabled = true; b.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: b.getAttribute('data-tl-addon'), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        b.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('tl:cart-changed'));
        setTimeout(function () { b.textContent = was; b.disabled = false; }, 1800);
      }).catch(function () {
        b.textContent = 'Try again'; b.disabled = false;
      });
    });
  });
})();

/* The basket had a message-card field writing to the order note. It was removed
   in favour of the per-rose "Gift note" on the product page, so its saver is
   gone too — order.note is now merchant-only and never customer-facing. */

/* ---- stem buttons drive the real variant select ---- */
(function () {
  var btns = [].slice.call(document.querySelectorAll('[data-tl-stem]'));
  var sel = document.getElementById('variant-select');
  if (!btns.length || !sel) return;
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var want = b.getAttribute('data-tl-stem');
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.indexOf(want) !== -1) { sel.selectedIndex = i; break; }
      }
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
    });
  });
})();


/* ---- announcement bar: rotates, pauses on hover or focus, stops on reduced motion ---- */
(function () {
  var bar = document.querySelector('[data-tl-announce]');
  if (!bar) return;
  var msgs = [].slice.call(bar.querySelectorAll('[data-tl-announce-msg]'));
  if (msgs.length < 2) return;
  var i = 0, timer = null;
  var wait = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(next) {
    var from = msgs[i];
    i = (next + msgs.length) % msgs.length;
    from.classList.remove('on');
    from.classList.add('out');
    setTimeout(function () { from.classList.remove('out'); }, 450);
    msgs[i].classList.add('on');
  }
  function play() { if (!still) { stop(); timer = setInterval(function () { show(i + 1); }, wait); } }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  var prev = bar.querySelector('[data-tl-announce-prev]');
  var next = bar.querySelector('[data-tl-announce-next]');
  if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
  if (next) next.addEventListener('click', function () { show(i + 1); play(); });
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', play);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', play);
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
  play();
})();


/* ---- next occasion: whichever order-by date comes first, then it rolls on ---- */
(function () {
  var box = document.querySelector('[data-tl-deadline]');
  if (!box) return;
  var nodes = [].slice.call(box.querySelectorAll('[data-occ]'));
  if (!nodes.length) { box.hidden = true; return; }
  var list = nodes.map(function (n) {
    return { name: n.getAttribute('data-name'), date: n.getAttribute('data-date'),
             lead: (function (v) { var x = parseInt(v, 10); return isNaN(x) ? 3 : x; })(n.getAttribute('data-lead')),
             verb: n.getAttribute('data-verb') || '' };
  });
  if (!list.length) return;

  var nameEl = box.querySelector('[data-dl-name]');
  var byEl = box.querySelector('[data-dl-by]');
  var clockEl = box.querySelector('[data-dl-clock]');
  var DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  var R = window.TLDelivery;
  function pad2(n) { n = +n; return (n < 10 ? '0' : '') + n; }
  function keyAdd(k, n) {
    var p = k.split('-'), d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    d.setUTCDate(d.getUTCDate() + n);
    return d.getUTCFullYear() + '-' + pad2(d.getUTCMonth() + 1) + '-' + pad2(d.getUTCDate());
  }
  function todayKey() {
    if (R) return R.plan().today;
    var d = new Date(); return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }
  function endOfDay(k) {
    return R ? R.londonInstant(k, 23, 59) : new Date(+k.slice(0, 4), +k.slice(5, 7) - 1, +k.slice(8, 10), 23, 59).getTime();
  }

  /* MM-DD repeats every year, so roll it to the next occurrence rather than letting
     it expire. A full date is treated as a one-off. */
  function occurrence(raw, today) {
    if (!raw) return null;
    var p = String(raw).split('-');
    if (p.length === 3 && +p[0] > 1900) return p[0] + '-' + pad2(p[1]) + '-' + pad2(p[2]);
    if (p.length === 2) {
      var y = +today.slice(0, 4), k = y + '-' + pad2(p[0]) + '-' + pad2(p[1]);
      return k < today ? (y + 1) + '-' + pad2(p[0]) + '-' + pad2(p[1]) : k;
    }
    return null;
  }

  function pick() {
    var now = Date.now(), today = todayKey(), best = null;
    list.forEach(function (o) {
      var occ = occurrence(o.date, today);
      if (!occ) return;
      var byKey = keyAdd(occ, -o.lead), by = endOfDay(byKey), time = '';
      /* an "order by" deadline must also leave time to make and post the roses —
         keep whichever is earlier, the shop's own lead or the delivery rules */
      if (R && !o.verb) {
        var ob = R.orderBy(occ);
        if (ob.at < by) { by = ob.at; byKey = ob.key; time = R.cutoffLabel(); }
      }
      if (by <= now) return;                       // deadline gone, skip to the next
      if (!best || by < best.by) best = { name: o.name, by: by, byKey: byKey, time: time, verb: o.verb };
    });
    return best;
  }

  function tick() {
    var next = pick();
    if (!next) { box.hidden = true; return; }
    box.hidden = false;
    nameEl.textContent = next.name;
    var verbEl = box.querySelector('[data-dl-verb]');
    if (verbEl) verbEl.textContent = next.verb && next.verb.length ? next.verb : (box.getAttribute('data-verb') || 'order by');
    var k = next.byKey.split('-'), d0 = new Date(Date.UTC(+k[0], +k[1] - 1, +k[2]));
    byEl.textContent = DAY[d0.getUTCDay()] + ' ' + d0.getUTCDate() + ' ' + MON[d0.getUTCMonth()] + (next.time ? ', ' + next.time : '');
    var ms = next.by - Date.now();
    var d = Math.floor(ms / 86400000), h = Math.floor(ms % 86400000 / 3600000), m = Math.floor(ms % 3600000 / 60000);
    clockEl.textContent = d > 0 ? (d + 'd ' + h + 'h left') : (h + 'h ' + m + 'm left');
  }
  tick();
  setInterval(tick, 60000);
})();


/* ---- character limits -----------------------------------------------------
   Three rules have to agree: a per-row cap, whether spaces count, and a shared
   budget across the rows in a group. maxlength can express none of them, so the
   limit lives here and the gauges read the same numbers. */
window.TL = window.TL || {};
window.TL.countChars = function (v, countSpaces) {
  return countSpaces ? (v || '').length : (v || '').replace(/\s/g, '').length;
};
window.TL.clampChars = function (v, max, countSpaces) {
  if (countSpaces) return (v || '').slice(0, max);
  var out = '', n = 0;
  for (var i = 0; i < (v || '').length; i++) {
    var ch = v[i];
    if (/\s/.test(ch)) { out += ch; continue; }
    if (n >= max) break;
    out += ch; n++;
  }
  return out;
};

(function () {
  function rowMax(inp) { return parseInt(inp.getAttribute('data-max-chars'), 10) || 15; }
  function spacesCount(inp) { return inp.getAttribute('data-count-spaces') === 'true'; }
  function groupOf(inp) { return inp.closest('[data-char-group]'); }

  function used(group) {
    var total = 0;
    [].slice.call(group.querySelectorAll('.imprint-row input')).forEach(function (n) {
      if (n.closest('.imprint-row').hidden) return;
      total += window.TL.countChars(n.value, spacesCount(n));
    });
    return total;
  }

  function paintGroup(group) {
    if (!group) return;
    var budget = parseInt(group.getAttribute('data-budget'), 10) || 0;
    var out = group.querySelector('[data-char-total]');
    if (out && budget) {
      var u = used(group);
      out.textContent = u + ' of ' + budget;
      group.classList.toggle('at-limit', u >= budget);
    }
  }

  function paintRow(row) {
    if (!row) return;
    var inp = row.querySelector('input'), g = row.querySelector('.gauge');
    if (!inp || !g) return;
    var max = rowMax(inp);
    while (g.children.length < max) g.appendChild(document.createElement('i'));
    while (g.children.length > max) g.removeChild(g.lastChild);
    var n = window.TL.countChars(inp.value, spacesCount(inp));
    [].slice.call(g.children).forEach(function (t, k) { t.classList.toggle('on', k < n); });
    row.classList.toggle('full', n >= max);
  }

  function handle(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest('.imprint-row');
    if (!row) return;
    var group = groupOf(t);
    var max = rowMax(t), spaces = spacesCount(t);

    /* the row cap first, then whatever is left of the shared budget */
    var v = window.TL.clampChars(t.value, max, spaces);
    if (group) {
      var budget = parseInt(group.getAttribute('data-budget'), 10) || 0;
      if (budget) {
        var others = 0;
        [].slice.call(group.querySelectorAll('.imprint-row input')).forEach(function (n) {
          if (n === t || n.closest('.imprint-row').hidden) return;
          others += window.TL.countChars(n.value, spacesCount(n));
        });
        var allowance = Math.max(0, budget - others);
        v = window.TL.clampChars(v, Math.min(max, allowance), spaces);
      }
    }
    if (v !== t.value) {
      var at = t.selectionStart;
      t.value = v;
      try { t.setSelectionRange(Math.min(at, v.length), Math.min(at, v.length)); } catch (err) {}
    }
    paintRow(row);
    paintGroup(group);
  }

  document.addEventListener('input', handle);
  function init() {
    [].slice.call(document.querySelectorAll('.imprint-row')).forEach(paintRow);
    [].slice.call(document.querySelectorAll('[data-char-group]')).forEach(paintGroup);
  }
  document.addEventListener('DOMContentLoaded', init);
  init();
  window.TL.refreshLimits = init;
})();


/* ---- keep the free-delivery bar honest after an AJAX add ---- */
(function () {
  function refresh() {
    var box = document.querySelector('[data-tl-freeship]');
    if (!box) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var target = parseInt(box.getAttribute('data-target'), 10) || 0;
      if (!target) return;
      var left = target - cart.total_price;
      var msg = box.querySelector('[data-tl-freeship-msg]');
      var fill = box.querySelector('[data-tl-freeship-fill]');
      var away = box.getAttribute('data-away') || '[amount] away from free delivery';
      var won = box.getAttribute('data-won') || 'Free delivery unlocked';
      if (left > 0) {
        msg.textContent = away.replace('[amount]', '£' + (left / 100).toFixed(2));
        box.classList.remove('freeship--won');
      } else {
        msg.textContent = won;
        box.classList.add('freeship--won');
      }
      fill.style.width = Math.min(100, cart.total_price / target * 100) + '%';
    }).catch(function () {});
  }
  document.addEventListener('tl:cart-changed', refresh);
})();


/* ---- remove a line, taking anything tied to it ---- */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drop(key) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { if (!r.ok) throw new Error('remove'); return r.json(); });
  }

  /* Extras carry "Goes with: <rose title> (TL-XXXX)". Pull the cart fresh before
     each one rather than caching keys — a line item key is rebuilt whenever a
     discount recalculates, so a list gathered up front can go stale mid-loop.
     Anything added on its own has no reference and is never touched. */
  function dropTied(ref) {
    var needle = '(' + ref + ')';
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hit = null;
        (cart.items || []).some(function (it) {
          var gw = (it.properties || {})['Goes with'];
          if (gw && String(gw).indexOf(needle) > -1) { hit = it.key; return true; }
          return false;
        });
        if (!hit) return false;
        return drop(hit).then(function () { return dropTied(ref); }).then(function () { return true; });
      });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-tl-remove]');
    if (!link) return;
    var key = link.getAttribute('data-tl-key');
    var line = parseInt(link.getAttribute('data-tl-remove'), 10);
    if (!key && !line) return;            /* nothing to work with — let the link go */
    e.preventDefault();
    var ref = (link.getAttribute('data-tl-ref') || '').trim();
    var href = link.getAttribute('href');
    link.textContent = 'Removing…';

    var first = key
      ? drop(key)
      : fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function (r) { if (!r.ok) throw new Error('remove'); return r.json(); });

    first
      .then(function () { return ref ? dropTied(ref) : false; })
      .then(function (cascaded) {
        document.dispatchEvent(new CustomEvent('tl:cart-changed'));
        if (cascaded) { window.location.reload(); return; }
        var item = link.closest('.cart-item, .cart-line');
        if (item) item.remove();
        if (!document.querySelector('.cart-item, .cart-line')) window.location.reload();
      })
      .catch(function () { window.location.href = href; });
  });
})();


/* ---- delivery date picker (basket) ----------------------------------------
   Draws a Monday-first month grid from the shared rules. Only days that can
   really be met are pressable. The choice is written to the basket through the
   Cart API straight away, because attributes posted with the form alone have
   been reported to go missing from orders. */
(function () {
  var R = window.TLDelivery;
  var box = document.querySelector('[data-tl-dd]');
  if (!R || !box) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cal = box.querySelector('[data-tl-dd-cal]');
  var chosenEl = box.querySelector('[data-tl-dd-chosen]');
  var hintEl = box.querySelector('[data-tl-dd-hint]');
  var errEl = box.querySelector('[data-tl-dd-error]');
  var WK = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  var p = R.plan();
  var selected = R.parseLong(box.getAttribute('data-current'));

  function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
  function hideError() { if (errEl) errEl.hidden = true; }

  function save(value) {
    box.classList.add('is-saving');
    var req = fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Delivery date': value } })
    }).then(function (r) {
      if (!r.ok) throw new Error('save');
      box.classList.remove('is-saving');
      if (value) hideError();
    }).catch(function () {
      box.classList.remove('is-saving');
      showError(box.getAttribute('data-msg-failed'));
    });
    R.pending = req;                 /* checkout waits for this before it checks */
    return req;
  }

  /* the product form reads this before letting anything into the basket */
  function publish() {
    if (selected) box.setAttribute('data-selected', selected);
    else box.removeAttribute('data-selected');
  }

  /* a date saved on an earlier visit may have passed, or fallen inside the cut-off */
  if (selected && !R.available(selected, p)) {
    selected = null;
    save('');
    showError(box.getAttribute('data-msg-stale'));
    var stale = box.querySelector('[data-tl-dd-basketline]');
    if (stale) stale.hidden = true;
  } else if (!selected && box.getAttribute('data-current')) {
    save('');                        /* unreadable value — clear it */
  }
  publish();

  var anchor = selected || p.earliest;
  var view = { y: +anchor.slice(0, 4), m: +anchor.slice(5, 7) };
  function ym(y, m) { return y + '-' + (m < 10 ? '0' : '') + m; }

  var noteEl = box.querySelector('[data-tl-dd-note]');

  function paintChoice() {
    if (!selected) {
      chosenEl.textContent = ''; hintEl.textContent = '';
      if (noteEl) noteEl.hidden = true;
      return;
    }
    chosenEl.textContent = 'Arriving ' + R.longDate(selected);
    /* DPD Next Day doesn't run on Saturdays, so a Saturday needs a Royal Mail service */
    hintEl.textContent = R.weekday(selected) === 6
      ? box.getAttribute('data-hint-saturday')
      : (selected === p.earliest ? box.getAttribute('data-hint-soonest') : box.getAttribute('data-hint-later'));
    if (noteEl) {
      var n = R.noteFor(selected);
      noteEl.textContent = n;
      noteEl.hidden = !n;
    }
  }

  function render() {
    p = R.plan();
    var first = ym(view.y, view.m) + '-01';
    var lead = (R.weekday(first) + 6) % 7;
    var count = new Date(Date.UTC(view.y, view.m, 0)).getUTCDate();
    var html = '<div class="dd-head">'
      + '<button type="button" class="dd-nav" data-dd-prev aria-label="Previous month"'
      + (ym(view.y, view.m) <= p.earliest.slice(0, 7) ? ' disabled' : '') + '>&lsaquo;</button>'
      + '<span class="dd-month">' + R.MONTHS[view.m - 1] + ' ' + view.y + '</span>'
      + '<button type="button" class="dd-nav" data-dd-next aria-label="Next month"'
      + (ym(view.y, view.m) >= p.latest.slice(0, 7) ? ' disabled' : '') + '>&rsaquo;</button>'
      + '</div><div class="dd-grid dd-wk" aria-hidden="true">';
    WK.forEach(function (w) { html += '<span>' + w + '</span>'; });
    html += '</div><div class="dd-grid">';
    for (var b = 0; b < lead; b++) html += '<span class="dd-blank"></span>';
    for (var d = 1; d <= count; d++) {
      var k = ym(view.y, view.m) + '-' + (d < 10 ? '0' : '') + d;
      var ok = R.available(k, p);
      html += '<button type="button" class="dd-day" data-key="' + k + '"'
        + ' aria-pressed="' + (k === selected) + '"'
        + ' aria-label="' + R.longDate(k) + (ok ? '' : ', not available') + '"'
        + (ok ? '' : ' disabled') + '>' + d + '</button>';
    }
    cal.innerHTML = html + '</div>';
    paintChoice();
  }

  cal.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button') : null;
    if (!t || t.disabled) return;
    if (t.hasAttribute('data-dd-prev')) { view.m--; if (view.m < 1) { view.m = 12; view.y--; } render(); return; }
    if (t.hasAttribute('data-dd-next')) { view.m++; if (view.m > 12) { view.m = 1; view.y++; } render(); return; }
    var k = t.getAttribute('data-key');
    if (!k || !R.available(k)) { render(); return; }
    selected = k;
    publish();
    render();
    save(R.longDate(k));
  });

  render();
})();


/* ---- card message (basket) ----------------------------------------------
   Its own cart attribute, not the order note: the note is where staff type
   internal things in the admin, and those must never reach a customer's box. */
(function () {
  var box = document.querySelector('[data-tl-cardmsg]');
  if (!box) return;
  var ta = box.querySelector('[data-tl-cardmsg-input]');
  var count = box.querySelector('[data-tl-cardmsg-count]');
  var state = box.querySelector('[data-tl-cardmsg-state]');
  if (!ta) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer;
  function paint() { if (count) count.textContent = (ta.value || '').length; }
  paint();
  ta.addEventListener('input', function () {
    paint();
    if (state) state.textContent = '';
    clearTimeout(timer);
    timer = setTimeout(function () {
      var req = fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Card message': ta.value } })
      }).then(function (r) {
        if (!r.ok) throw new Error('card');
        if (state) state.textContent = ta.value.length ? 'Saved' : '';
      }).catch(function () {
        if (state) state.textContent = 'Not saved — try again';
      });
      /* checkout waits for this the same way it waits for the date */
      if (window.TLDelivery) window.TLDelivery.pending = req;
    }, 700);
  });
})();

/* ---- checkout needs a delivery date that can still be met ----------------
   A required field on its own has been reported not to stop checkout, so both
   checkout buttons (basket page and drawer) are gated here. The check reads the
   live basket, so a date picked in another tab still counts. */
(function () {
  var R = window.TLDelivery;
  if (!R) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Checkout is Shopify's own page and a theme can't add to it without Plus —
     but it does list each item's details. So before letting the customer
     through, write the chosen date onto every item as a detail, first in the
     list, and it shows under the item in checkout, on the confirmation email
     and on the order. Extras tied to a rose are left alone: they arrive with it.
     The basket is re-read before each change, because line keys change. */
  function stampLines(label, message, guard) {
    if (guard > 15) return Promise.resolve();
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        (cart.items || []).some(function (it) {
          var props = it.properties || {};
          if (props['Goes with']) return false;
          if (props['Delivery date'] === label && (props['Card message'] || '') === message) return false;
          line = it; return true;
        });
        if (!line) return;
        var props = { 'Delivery date': label };
        if (message) props['Card message'] = message;
        Object.keys(line.properties || {}).forEach(function (k) {
          if (k !== 'Delivery date' && k !== 'Card message') props[k] = line.properties[k];
        });
        var body = { id: line.key, quantity: line.quantity, properties: props };
        var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
        if (plan && plan.id) body.selling_plan = plan.id;       /* keep a subscription a subscription */
        return fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error('stamp');
          return stampLines(label, message, guard + 1);
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[name="checkout"]') : null;
    if (!btn) return;
    if (btn.getAttribute('data-dd-pass') === '1') { btn.removeAttribute('data-dd-pass'); return; }
    e.preventDefault();
    e.stopPropagation();
    var label = btn.textContent;
    Promise.resolve(R.pending)
      .then(function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var k = R.parseLong((cart.attributes || {})['Delivery date']);
        if (k && R.available(k)) {
          btn.textContent = 'Preparing checkout…';
          /* the date is already on the order as a cart attribute, so a failed
             stamp only costs the checkout display — never block the sale on it */
          stampLines(R.longDate(k), (cart.attributes || {})['Card message'] || '', 0)
            .catch(function () {})
            .then(function () { btn.textContent = label; btn.setAttribute('data-dd-pass', '1'); btn.click(); });
          return;
        }
        var picker = document.querySelector('[data-tl-dd]');
        if (picker) {
          var err = picker.querySelector('[data-tl-dd-error]');
          if (err) { err.textContent = picker.getAttribute('data-msg-required'); err.hidden = false; }
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          window.location.href = root + 'cart#delivery-date';
        }
      })
      /* if the basket can't be read at all, don't hold the sale hostage */
      .catch(function () { btn.setAttribute('data-dd-pass', '1'); btn.click(); });
  }, true);
})();


/* ---- drawer: show the chosen date only while it can still be met ---- */
(function () {
  var R = window.TLDelivery;
  var line = document.querySelector('[data-tl-dd-drawer]');
  if (!R || !line) return;
  var k = R.parseLong(line.getAttribute('data-date'));
  var ok = !!k && R.available(k);
  var set = line.querySelector('[data-dd-set]'), unset = line.querySelector('[data-dd-unset]');
  if (set) set.hidden = !ok;
  if (unset) unset.hidden = ok;
})();
